<template>
  <v-dialog
    v-model="value"
    transition="dialog-top-transition"
    max-width="600"
  >
      <v-card>
        <v-toolbar
          color="primary"
          dark
          dense
        >{{ mode==='add' ? 'Добавление' : 'Редактирование' }} должности </v-toolbar>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="posShortName"
                  label="Краткое наименование должности"
                  type="text"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                v-model="posFullName"
                  label="Полное наименование или код должности"
                  type="text"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="justify-end">
          <v-btn
            text
            @click="$emit('input', false)"
          >Отмена</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            @click="doAction"
            :disabled="saveDisabled"
          >Сохранить</v-btn>
        </v-card-actions>
      </v-card>
  </v-dialog>
</template>

<script>
import { ORG_ADD_POSITION, ORG_UPD_POSITION } from '@/store/actions/org'
import { UI_SNACKBAR } from '@/store/actions/ui'

export default {
  name: 'orgAddPositionDialog',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    org: {
      type: Object,
      default: function () {
        return {
          INST_UUID: null
        }
      }
    },
    pos: {
      type: Object,
      default: function () {
        return {}
      }
    },
    mode: {
      type: String,
      default: 'add'
    }
  },
  data () {
    return {
      posShortName: '',
      posFullName: ''
    }
  },
  watch: {
    pos (val) {
      if (val) {
        this.posShortName = val.POS_CODE
        this.posFullName = val.POS_NAME
      }
    }
  },
  computed: {
    saveDisabled: {
      get: function () {
        const snReady = Boolean(this.posShortName && this.posShortName.trim())
        const fnReady = Boolean(this.posFullName && this.posFullName.trim())
        return !(snReady && fnReady)
      }
    }
  },
  methods: {
    doAction () {
      if (this.mode === 'add') {
        this.addPos()
      } else {
        this.updPos()
      }
    },
    addPos () {
      const params = {
        SHORT_NAME: this.posShortName,
        FULL_NAME: this.posFullName,
        INST_UUID: this.org.INST_UUID
      }
      this.$store.dispatch(ORG_ADD_POSITION, params)
        .then((resp) => {
          this.$emit('onPositionAdded', resp)
        })
        .catch((err) => {
          this.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: 'Ошибка добавления записи' + err })
          console.log('Ошибка ', err)
        })
    },
    updPos () {
      const params = {
        SHORT_NAME: this.posShortName,
        FULL_NAME: this.posFullName,
        INST_UUID: this.org.INST_UUID,
        IPOS_UUID: this.pos.IPOS_UUID
      }
      this.$store.dispatch(ORG_UPD_POSITION, params)
        .then((resp) => {
          this.$emit('onPositionUpdate', resp)
        })
        .catch((err) => {
          this.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: 'Ошибка обновления записи' + err })
          console.log('Ошибка ', err)
        })
    }
  }
}
</script>
